import { useEffect } from 'react'

import dayjs from 'dayjs'

import { useAppSelector } from 'src/Hooks/redux'
import { getUser } from 'src/Redux/auth-process/userSlice/selectors'
import { useSourceBusterEvents } from 'src/Hooks/useSourceBusterEvents'
import {
  clearPendingGoogleAuth,
  hasPendingGoogleAuth,
} from 'src/Utils/pendingGoogleAuth'
import { hasSentSignup, markSignupSent } from 'src/Utils/sentSignupUsers'

const NEW_ACCOUNT_THRESHOLD_MINUTES = 1

export const isNewAccount = (createdAt?: string): boolean =>
  Boolean(createdAt) &&
  dayjs().diff(dayjs(createdAt), 'minute', true) < NEW_ACCOUNT_THRESHOLD_MINUTES

export const useGoogleSignupEvent = (): null => {
  const { id, createdAt } = useAppSelector(getUser)
  const { sourceBusterLoginEvent } = useSourceBusterEvents()

  useEffect(() => {
    if (!id || !createdAt || !hasPendingGoogleAuth()) {
      return
    }

    clearPendingGoogleAuth()

    const userId = String(id)

    if (!isNewAccount(createdAt) || hasSentSignup('google_signup', userId)) {
      return
    }

    markSignupSent('google_signup', userId)
    sourceBusterLoginEvent({ eventName: 'google_signup' })
  }, [id, createdAt, sourceBusterLoginEvent])

  return null
}
